import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { IntegratorService, Integrator } from 'app/services/integrator.service';
import { UserService } from 'app/services/user.service';
import { TableColumn, CommonTableService } from 'app/services/common-table.service';
import { ToastrService } from 'ngx-toastr';
import { PaneControlService } from 'app/services/pane-control.service';

@Component({
	selector: 'app-config-integrators',
	templateUrl: './config-integrators.component.html',
	styleUrls: ['./config-integrators.component.css', './../config-users/config-users.component.css']
})
export class ConfigIntegratorsComponent implements OnInit {

	@ViewChild('operationsTempl', { static: false }) operationsTempl: TemplateRef<any>;
	@ViewChild('adminUsersTempl', { static: false }) adminUsersTempl: TemplateRef<any>;
	public integrators: Integrator[] = [];
	public selectedIntegrator: Integrator = null;

	// public currentIntegrators: Integrator[] = [];
	public columns: TableColumn[] = [];

	constructor(
		private toastr: ToastrService,
		private integratorService: IntegratorService,
		private tableService: CommonTableService,
		private paneService: PaneControlService,
		private userService: UserService
	) { }

	public changeIntegrator() {
		
	}
	// public async addIntegrator() {
	// 	if (this.selectedIntegrator && this.userService.getUserInfo().isAdmin) {
	// 		try {
	// 			await this.integratorService.addIntegratorClient(this.selectedIntegrator.cusId, this.userService.getUserInfo().customerId, this.userService.getUserInfo().userId);
	// 			await this.setTable();
	// 			this.toastr.success('Successfull invited.');
	// 		} catch (err) {
	// 			console.log(err);
	// 		}
	// 	}
	// }
	public async inviteIntegrator(row: Integrator) {
		try {
			await this.integratorService.addIntegratorClient(row.cusId, this.userService.getUserInfo().customerId, this.userService.getUserInfo().userId);
			await this.setTable();
			this.toastr.success('Successfully invited.');
		} catch (err) {
			console.log(err);
			this.toastr.error('Operation failed.');
		}
	}
	public async uninviteIntegrator(row: Integrator) {
		try {
			await this.integratorService.deleteIntegratorClient(row.giaId);
			await this.setTable();
			this.toastr.success('Successfully univited.');
		} catch (err) {
			console.log(err);
			this.toastr.error('Operation failed.');
		}
	}
	private async setTable() {
		const currentIntegrators = await this.integratorService.getIntegrators(this.userService.getUserInfo().customerId);
		const integrators = this.integrators.map(i => i); // Create a new object for the rows so that the rows will update
		integrators.forEach((i) => {
			const c = currentIntegrators.find((c) => i.cusId === c.cusId);
			if (c) {
				i.isSelected = true;
				i.giaId = c.giaId;
			} else {
				i.isSelected = false;
				i.giaId = null;
			}
		});
		// this.currentIntegrators = currentIntegrators;

		this.integrators = integrators.sort((a, b) => {
			return (a.isSelected === b.isSelected) ? 0 : a.isSelected ? -1 : 1;
		});
	}
	private setColumns() {
		const meta: { name;prop;width?;cellTempl?;align?; headerAlign?; }[] = [
			{ name: 'Integrator', prop: 'nameShort', width: 150, headerAlign: 'L' },
			{ name: 'Description', prop: 'nameLong', headerAlign: 'L'},
			{ name: 'Administrator', prop: 'adminUsers', cellTempl: this.adminUsersTempl, headerAlign: 'L' }, // TODO
			{ name: ' ', prop: 'operations', cellTempl: this.operationsTempl, align: 'R' }
		];
		const columns: TableColumn[] = [];
		meta.forEach((m) => columns.push(this.tableService.setNewColumn(m.prop, m.name, {
			width: m.width,
			cellTemplate: m.cellTempl,
			align: m.align,
			headerAlign: m.headerAlign
		})));
		this.columns = columns;
	}
	public setRowClass(row: Integrator) {
		if (!row.isSelected) {
			return 'uninvited-integrator';
		}
	}
	async ngOnInit() {
		// Tell paneControl current pane is switched to config, so that the highlighted menu item can change to config
		this.paneService.currPane.next({
			paneType: 'config',
			submenu: 'configIntegrators'
		});

		this.setColumns();
		if (!this.integratorService.integrators || !this.integratorService.integrators.length) {
			await this.integratorService.getIntegrators(null, true);
		}
		this.integrators = this.integratorService.integrators;
		this.setTable();
	}

}
